exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cvd3.cv-scatter .cv-groups .cv-point.hover,\n.cvd3 .cv-groups .cv-point.hover {\n  stroke-opacity: 0.85 !important;\n  fill-opacity: 0 !important;\n  stroke-width: 5px;\n}\n\n.cvd3 .cv-axis.cv-x path.domain {\n  stroke-opacity: 0.85;\n}\n\n.cvd3 .cv-axis.cv-y path.domain {\n  stroke-opacity: 0.85;\n}\n\n.cv-selectable.cv-point {\n  cursor: pointer;\n}\n\n", ""]);

// exports
